<app-toolbar>  
    <app-tool-button text="Actualizar" i18n-text (click)="refresh();" color="has-color-blue" icon="fa-sync"></app-tool-button>
    <app-tool-button text="Filtre" i18n-text (click)="onFilterClicked();" color="has-color-orange" icon="fa-filter"></app-tool-button> 
    <app-tool-button text="Excel" i18n-text (click)="generateExcel();" color="has-color-darkgreen" icon="fa-file-excel"></app-tool-button>
    <app-tool-button-permissions [permission]="this.authService.Pages.Tiquets"></app-tool-button-permissions>
</app-toolbar>
<div class="row"><app-filter-selector [filter]="this.filter"></app-filter-selector></div>
<app-tiquets-client-table #tiquetsClientTable [sharedFilter]="this.filter" (currentCount)="this.setBadgeCount($event, 1)"></app-tiquets-client-table>
